import * as React from 'react';
import styled from 'styled-components';
import { getTextColor } from 'utils/colors';

interface IProps {
  children: React.ReactNode;
  isActive?: boolean;
  className?: string;
  color: string;
  activeColor: string;
}

export const CircleNumber: React.SFC<IProps> = props => {
  const background = props.isActive ? props.activeColor : props.color;
  const color = props.isActive
    ? getTextColor(props.activeColor)
    : getTextColor(props.color);
  return (
    <Container
      style={{ background, color }}
      className={props.className}
      isActive={props.isActive}
    >
      <span>{props.children}</span>
    </Container>
  );
};

const Container = styled.div<{ isActive?: boolean }>`
  width: 30px;
  height: 30px;
  border-radius: 100%;
  font-size: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: ${p => (!p.isActive ? '#333' : 'white')};
  font-weight: ${p => (p.isActive ? 'bold' : 'initial')};
  background: ${p => (!p.isActive ? '#eee' : '#333')};
`;

export default CircleNumber;



// WEBPACK FOOTER //
// ./src/components/CircleNumber/CircleNumber.tsx